import React from 'react';
import ContentLoader from 'react-content-loader';

let isProduct = [1, 2, 3, 4, 5, 6];
let isColumn = [1, 2, 3, 4, 5, 6];


const ProductLoader = (props) => (
    isColumn.map((item) => {
        return (
            <div key={`${item}_idx`} className="row">
                {
                    isProduct.map(num => {
                        return (
                            <div key={num} className="col">
                                <div >
                                    <ContentLoader
                                        height={50}
                                        width="100%"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                    >
                                        <rect height="20" rx="1" ry="1" width="200" x='0' y="20" />
                                    </ContentLoader>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        )
    })
);



export {
    ProductLoader,
}
